module.exports = __webpack_public_path__ + "4aeda0ca0ddd8bd04858a274a8789f51.svg";